import { apiClient } from './api'
import type { Measurement, MeasurementFilters, MeasurementListResponse, ChartDataPoint } from '@/types/measurement.types'

export const measurementService = {
  getMeasurements: async (deviceId: string, filters?: MeasurementFilters): Promise<MeasurementListResponse> => {
    const params: any = {}
    if (filters?.startDate) params.startDate = filters.startDate
    if (filters?.endDate) params.endDate = filters.endDate
    if (filters?.limit) params.pageSize = filters.limit
    if (filters?.offset) params.page = Math.floor((filters.offset || 0) / (filters.limit || 100)) + 1

    const { data } = await apiClient.get(`/measurements/${deviceId}`, { params })
    return data
  },

  getLatestMeasurement: async (deviceId: string): Promise<Measurement | null> => {
    const { data } = await apiClient.get(`/measurements/${deviceId}/latest`)
    return data
  },

  getChartData: async (deviceId: string, parameter: string, filters?: MeasurementFilters): Promise<ChartDataPoint[]> => {
    const params: any = { parameter }
    if (filters?.startDate) params.startDate = filters.startDate
    if (filters?.endDate) params.endDate = filters.endDate

    const { data } = await apiClient.get(`/measurements/${deviceId}/chart-data`, { params })
    return data
  },

  exportMeasurements: async (deviceId: string, format: string, startDate: string, endDate: string, fields: string[]): Promise<Blob> => {
    const response = await apiClient.post(
      `/measurements/${deviceId}/export`,
      { format, startDate, endDate, fields },
      { responseType: 'blob' }
    )
    return response.data
  }
}
